import React from 'react';
import { SitemapItems } from '../../../../types';
import * as S from './styles';

type Props = Pick<SitemapItems, 'path' | 'title'>;

const SitemapItem = ({ path, title }: Props) => {
  return (
    <S.SitemapItem>
      <S.SitemapLink to={path}>{title}</S.SitemapLink>
    </S.SitemapItem>
  );
};

export default SitemapItem;
